import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { mergeMap, map } from 'rxjs/operators';
import { ForkJoinObservable } from 'rxjs/observable/ForkJoinObservable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import { environment } from '../../environments/environment';
import { IBid, Bid } from '../models/IBid';
import { Utils } from '../Utils';
import { INatRepCommandResult } from '../models/INatRepCommandResult';
import { INatRepQuotasCalculated } from '../models/INatRepQuotasCalculated';
import { INatRepQuotasRequest } from '../models/INatRepQuotasRequest';
import { INatRepPerformanceChart, INatRepPerformanceChartPoint } from '../models/INatRepPerformanceChart';

@Injectable()
export class NatRepServiceService {
  natRepUrl: string;

  constructor(private http: HttpClient) {
    this.natRepUrl = environment.natRepUrl;
  }

  private getFezaHeaderAndOptions(correlationId: string = null) {
    return {
      headers: new HttpHeaders({ 'X-Correlation-ID': correlationId == null ? Utils.generateUUID() : correlationId })
    };
  }

  public GetSourceExcelPath(natRepSourceName: string, countryCode: string): string {
    if (natRepSourceName === undefined)
      natRepSourceName = "";
    if (countryCode === undefined)
      countryCode = "";
    return this.natRepUrl + `/api/v1/natrep/source?natRepSourceName=${natRepSourceName}&natRepSourceCountryCode=${countryCode}`;
  }

  public GetSourceNames(): Observable<string[]> {
    return this.http.get<string[]>(this.natRepUrl + `/api/v1/natrep/source/names`, this.getFezaHeaderAndOptions());
  }

  public DeleteNatRepSource(natRepSourceName: string, countryCode: string): Observable<INatRepCommandResult> {
	  if (countryCode === undefined
      || countryCode == null
      || countryCode === 'undefined' 
		  || countryCode === 'null'
		  || countryCode.length < 2)
      countryCode = "";
    return this.http.delete<INatRepCommandResult>(this.natRepUrl + `/api/v1/natrep/source?natRepSourceName=${natRepSourceName}&natRepSourceCountryCode=${countryCode}`, this.getFezaHeaderAndOptions());
  }

  public UpdateNatRepSource(natRepSourceName: string, countryCode: string, data: FormData): Observable<INatRepCommandResult> {
    if (countryCode === undefined)
      countryCode = "";
    return this.http.post<INatRepCommandResult>(this.natRepUrl + `/api/v1/natrep/source?natRepSourceName=${natRepSourceName}&natRepSourceCountryCode=${countryCode}`, data, this.getFezaHeaderAndOptions());
	}


  public CalculateNatRepQuotaPercentageWithPanelEstimate(natRepQuotasRequest: INatRepQuotasRequest, correlationId:string): Observable<INatRepQuotasCalculated> {
    return this.http.post<INatRepQuotasCalculated>(this.natRepUrl + `/api/v1/natrep/quota-percentages-panel-estimate`, natRepQuotasRequest,
      this.getFezaHeaderAndOptions(correlationId));
  }

  public getPerformanceChart(): Observable<INatRepPerformanceChart> {
    return this.http.get<INatRepPerformanceChart>(this.natRepUrl + `/api/v1/natrep/Chart`, this.getFezaHeaderAndOptions());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/nat-rep-service.service.ts